/**
 * View component for /user-modules/:userModuleId
 *
 * Displays a single userModule from the 'byId' map in the userModule reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userModuleActions from '../userModuleActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userModule components
import UserModuleLayout from '../components/UserModuleLayout.js.jsx';

// import userModule css modules
import userModuleStyles from '../userModuleModuleStyles.css';


class SingleUserModule extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userModuleActions.fetchSingleIfNeeded(match.params.userModuleId));
  }

  render() {
    const { userModuleStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual userModule object from the map
     */
    const selectedUserModule = userModuleStore.selected.getItem();

    const isEmpty = (
      !selectedUserModule
      || !selectedUserModule._id
      || userModuleStore.selected.didInvalidate
    );

    return (
      <UserModuleLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single User Module </h3>
              {isEmpty ?
                (userModuleStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userModuleStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedUserModule.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE User Module </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the UserModule would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </UserModuleLayout>
    )
  }
}

SingleUserModule.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userModuleStore: store.userModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleUserModule)
);



// WEBPACK FOOTER //
// modules/userModule/views/SingleUserModule.js.jsx